import Box from "@mui/material/Box";
import { withProviders } from "./providers";
import { Routing } from "pages";
import { CasdoorSDK } from "shared/libs/casdoor/config";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const App = () => {
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    !localStorage.getItem("token") &&
      !params.get("code") &&
      CasdoorSDK.signin_redirect();
    !localStorage.getItem("token") &&
      setTimeout(() => {
        !localStorage.getItem("token") &&
          CasdoorSDK.exchangeForAccessToken()
            .then((resp) => {
              localStorage.setItem("token", resp.access_token);
              setParams((prev) => {
                prev.delete("code");
                prev.delete("state");
                return prev;
              });
            })
            .catch((err) => {
              CasdoorSDK.signin_redirect();
              localStorage.removeItem("token");
              setParams((prev) => {
                prev.delete("code");
                prev.delete("state");
                return prev;
              });
              console.log(err);
            });
      }, 1000);
  }, [setParams, params]);

  return <Box>{localStorage.getItem("token") && <Routing />}</Box>;
};

export default withProviders(App);
